@import '../../styles/variables.scss';
@import '../../styles/mixins.scss';

.product-card {
  display: flex;
  flex-direction: column;
  position: relative;
  transition: var(--transition);
  height: 100%;
}

.badges {
  display: flex;
  gap: 0.5rem;
  position: absolute;
  top: 1rem;
  left: 1rem;
  z-index: 1;
}

.product-info {
  margin-top: 0.25rem;
  padding: 0 0.5rem;
  word-wrap: break-word;
  overflow-wrap: break-word; // same as word-wrap (word-wrap is an alias for legacy)

  @include media-breakpoint-up(md) {
    padding: 0 1rem;
  }
}

.product-title {
  font-size: 0.875rem;
  font-weight: 700;
  margin-bottom: 0.25rem;
  @include text-overflow();

  @include media-breakpoint-up(sm) {
    font-size: 1rem;
  }

  @include media-breakpoint-up(md) {
    font-size: 1.25rem;
    margin-bottom: 0.5rem;
  }
}

.product-prices {
  display: flex;
  align-items: baseline;
  font-weight: 500;
  margin-bottom: 0;

  &.has-compare-at-price {
    .product-price {
      color: $primary;
    }
  }
}

.product-price {
  font-size: 0.875rem;
  white-space: nowrap;

  @include media-breakpoint-up(sm) {
    display: inline-block;
    font-size: 1rem;
  }
}

.product-compare-at-price {
  font-size: 0.75rem;
  text-decoration: line-through;
  white-space: nowrap;
  margin-left: 0.5rem;

  @include media-breakpoint-up(sm) {
    display: inline-block;
    font-size: 0.875rem;
  }
}

.favourite-toggler {
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
  padding: 0.75rem;
  background-color: transparent;
  border: none;
  border-radius: 50%;
  transition: var(--transition);
  color: var(--bs-body-color);
  line-height: 1;

  .icon {
    fill: var(--bs-body-bg);
    transition: transform 0.2s ease;
  }

  &:focus {
    outline: none;
  }

  @media (hover: hover) {
    &:hover {
      background-color: rgba($primary, 0.1);

      .icon {
        &:global {
          animation: heartbeat 2s ease-in-out infinite both; // defined in common.scss (that is why we need to use :global)
        }
      }
    }
  }

  &:active {
    .icon {
      transform: scale(0.8);
    }
  }

  &.active {
    .icon {
      fill: $primary;
    }
  }
}
